
import { Options } from "vue-class-component";
import BaseTag from "../BaseTag.vue";

@Options({})
export default class IziCard extends BaseTag {}
